import { render, staticRenderFns } from "./bookLink.vue?vue&type=template&id=7042e089&scoped=true&"
import script from "./bookLink.vue?vue&type=script&lang=js&"
export * from "./bookLink.vue?vue&type=script&lang=js&"
import style0 from "./bookLink.vue?vue&type=style&index=0&id=7042e089&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7042e089",
  null
  
)

export default component.exports